import { BRANCHING_QUESTION_ANSWERS_MAX_COUNT } from "../../types/constants";
import { SurveyQuestionType } from "../../types/models";
import { type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";

export const allowedBranchingQuestionTypes = [SurveyQuestionType.SingleChoiceTextQuestion];

export const getAnswersCount = (question: SurveyQuestion<any>) => {
  const count = question.answers.length;

  return question.otherAnswerOptions?.includeOtherAsAnswer ? count + 1 : count;
};

export const isAllowedBranchingQuestionType = (type: SurveyQuestionType) => {
  return allowedBranchingQuestionTypes.includes(type);
};

export const answersLimitReached = (question: SurveyQuestion<any>) => {
  return !!question.isBranching && getAnswersCount(question) >= BRANCHING_QUESTION_ANSWERS_MAX_COUNT;
};

export const nameofWithPrefix = <T>(prefix: string) => {
  return (name: keyof T) => `${prefix}${String(name)}`;
};
